import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAME } from './constants';
import { SiteOwnerTestResultsContainerState } from './siteownertestresults';
import { Test } from '../../domains/results';

const initialState: SiteOwnerTestResultsContainerState = {
  listTests: [],
  page: 0,
  pageSize: 20,
  total: 0,
  isFetching: false,
  search: '',
};

export const siteOwnerTestresultsSlice = createSlice({
  name: SLICE_NAME,

  initialState,

  reducers: {
    setListTests: (state, action: PayloadAction<Test[]>) => {
      state.listTests = action.payload;
    },
    addTests: (state, action: PayloadAction<Test[]>) => {
      state.listTests = state.listTests.concat(action.payload);
    },
    toggleCheckTest: (state, action: PayloadAction<string>) => {
      const test = state.listTests.find((t) => t.id === action.payload);
      if (test) {
        test.checked = !test.checked;
      }
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },
    setIsFetching: (state, action: PayloadAction<boolean>) => {
      state.isFetching = action.payload;
    },
  },
});

export const {
  setListTests,
  setPage,
  setSearch,
  setTotal,
  setIsFetching,
  addTests,
  toggleCheckTest,
} = siteOwnerTestresultsSlice.actions;

export default siteOwnerTestresultsSlice.reducer;
